import { render, staticRenderFns } from "./inscription-form.vue?vue&type=template&id=50dc37b9&"
import script from "./inscription-form.component.ts?vue&type=script&lang=ts&"
export * from "./inscription-form.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kevinmathieu/crr-sl-fr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dc37b9')) {
      api.createRecord('50dc37b9', component.options)
    } else {
      api.reload('50dc37b9', component.options)
    }
    module.hot.accept("./inscription-form.vue?vue&type=template&id=50dc37b9&", function () {
      api.rerender('50dc37b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/fo/components/inscription-form/inscription-form.vue"
export default component.exports